export enum LANGUAGE {
	VN = "vn",
	EN = "en",
}
